import { render, staticRenderFns } from "./InquiryInfo.vue?vue&type=template&id=05f9bc65&"
import script from "./InquiryInfo.vue?vue&type=script&lang=js&"
export * from "./InquiryInfo.vue?vue&type=script&lang=js&"
import style0 from "./InquiryInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports